const KEYS: Array<[string, string]> = [
  ['j / k', 'Next / previous conversation'],
  ['Enter', 'Open'],
  ['Esc', 'Close, or clear the selection'],
  ['x', 'Select'],
  ['Ctrl+A (⌘A)', 'Select all'],
  ['Ctrl-click (⌘-click)', 'Add to the selection'],
  ['Shift-click', 'Select a range'],
  ['Long press', 'Select (then tap to add more, on a touchscreen)'],
  ['e', 'Archive'],
  ['#', 'Delete'],
  ['s', 'Flag or unflag'],
  ['u', 'Mark unread'],
  ['r', 'Reply'],
  ['a', 'Reply all'],
  ['f', 'Forward'],
  ['c', 'New message'],
  ['/', 'Search'],
  ['?', 'This list'],
];

export function Shortcuts({ onClose }: { onClose: () => void }): JSX.Element {
  return (
    <div className="modal-scrim" role="presentation" onClick={onClose}>
      <div
        className="shortcuts"
        role="dialog"
        aria-label="Keyboard shortcuts"
        onClick={(e) => e.stopPropagation()}
      >
        <h3>Keyboard shortcuts</h3>
        <dl>
          {KEYS.map(([key, what]) => (
            <div key={key}>
              <dt>
                {key.split(' / ').map((k, i) => (
                  <span key={k}>
                    {i > 0 && ' / '}
                    <kbd>{k}</kbd>
                  </span>
                ))}
              </dt>
              <dd>{what}</dd>
            </div>
          ))}
        </dl>
        <button
          type="button"
          className="btn ghost"
          style={{ width: 'auto' }}
          onClick={onClose}
          autoFocus
        >
          Close
        </button>
      </div>
    </div>
  );
}
